export default "__VITE_ASSET__DcyP9nDV__"